import React from 'react';
// Components
import { Button } from '../../buttons';
import UploadImageIcon from './UploadImageIcon';
// Utils
import { formatMessage, FormattedMessage } from '@/utils/i18n';
import Nullable from '@/types/nullable';

type Props = {
  imgUrl?: Nullable<string>;
  i18nPath: string;
  showUploadImageModal: () => void;
  showDeleteImageModal: () => void;
};

const ImagePreview = ({ imgUrl, showUploadImageModal, showDeleteImageModal, i18nPath }: Props) => {
  const titleMessage = formatMessage(`${i18nPath}.Title`);
  const uploadMessage = formatMessage(`${i18nPath}.Upload`);
  const editMessage = formatMessage(`${i18nPath}.Edit`);
  const deleteMessage = formatMessage(`${i18nPath}.Delete`);

  const renderUploadButton = () => (
    <>
      {!imgUrl && (
        <Button onClick={showUploadImageModal} className="upload" aria-label={`${uploadMessage} ${titleMessage}`}>
          {uploadMessage}
          <i className="icon-ds-file-upload" />
        </Button>
      )}
    </>
  );

  const renderImageActionButtons = () => (
    <>
      {imgUrl && (
        <>
          <Button onClick={showUploadImageModal} aria-label={`${editMessage} ${titleMessage}`}>
            {editMessage}
            <i className="icon-ds-edit" />
          </Button>
          <Button onClick={showDeleteImageModal} aria-label={`${deleteMessage} ${titleMessage}`}>
            {deleteMessage}
            <i className="icon-ds-delete" />
          </Button>
        </>
      )}
    </>
  );

  return (
    <div className="image-preview">
      <UploadImageIcon aria-label={`${titleMessage} ${uploadMessage}`} onClick={showUploadImageModal} imgUrl={imgUrl} imgAlt={`${titleMessage}`} />
      <div className="image-text-actions">
        <FormattedMessage tagName="h3" id={`${i18nPath}.Title`} />
        <FormattedMessage tagName="label" id={`${i18nPath}.Description`} />
        <div className="actions">
          {renderUploadButton()}
          {renderImageActionButtons()}
        </div>
      </div>
    </div>
  );
};

export default ImagePreview;
